/**

 * Custom hook , to check permission on feature/component level
 *
 * Add pages here with component id : true/false
 * Import this hook and pass userDetails
 * Component id should match in below object . true for accessing else false.
 */

import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { MarketRoleAccess } from '../utils/Config';
import { REGIONAL_USER_TYPE, CHANNEL_USER_TYPE, CORE_USER, GENERAL_USER } from '../utils/Constants';
import { useOkta } from './oktaHook';

export const CheckPermission = () => {
  const { userDetails } = useOkta();
  const getUserDetails = () => {
    return {
      role: userDetails.roles,
      BU: userDetails.BUs
    };
  };
  const selectedBu = useSelector((state) => state?.cycle?.selectedBu);
  const [userType, setUserType] = useState('');
  const [currentVotingTeam, setCurrentVotingTeam] = useState('');
  const [currentDecisionTeam, setCurrentDecisionTeam] = useState('');
  const [currentCompletionTeam, setCurrentCompletionTeam] = useState('');

  const userInfo = getUserDetails();
  const currentPath = window.location.pathname;
  const progressStep = useSelector((state) => state.feedbackCollation.stepperStatus);
  const decisionCentralRules = useSelector((state) => state.decisionMakingCentralRules);
  const { decisionStepperStatus } = decisionCentralRules;
  let pageAccess = '';

  const getUserLevelInfo = () => {
    try {
      setUserType(progressStep?.userFunctionName);
      let taskName = progressStep.stepperStatus.filter((item) => item.status === 'In Progress')[0]
        ?.taskName;
      setCurrentVotingTeam(taskName);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    if (selectedBu) {
      getUserLevelInfo();
    }
  }, [selectedBu]);
  useEffect(() => {
    if (decisionStepperStatus) {
      setUserType(progressStep?.userFunctionName);
      let decisionTeam = decisionStepperStatus?.finalDecision?.status === 'In Progress';
      let completionTeam = decisionStepperStatus?.executeActions?.status === 'In Progress';
      setCurrentDecisionTeam(decisionTeam);
      setCurrentCompletionTeam(completionTeam);
    }
  }, [decisionStepperStatus]);
  // Steering Reco team for TPO-user
  if (currentVotingTeam === 'Steering Reco') {
    if (userInfo.role[0] === GENERAL_USER) {
      if (userType === REGIONAL_USER_TYPE || userType === CHANNEL_USER_TYPE) {
        pageAccess = MarketRoleAccess['Regional']?.pages[currentPath];
      }
      if (userType !== REGIONAL_USER_TYPE || userType !== CHANNEL_USER_TYPE) {
        pageAccess = MarketRoleAccess['Functional']?.pages[currentPath];
      }
    }
  }

  // Functional Feedback for TPO-User
  if (currentVotingTeam === 'Functional Feedback') {
    if (userInfo.role[0] === GENERAL_USER) {
      if (userType === REGIONAL_USER_TYPE || userType === CHANNEL_USER_TYPE) {
        pageAccess = MarketRoleAccess['Regional']?.pages[currentPath];
      }
    }
    if (userInfo.role[0] === CORE_USER) {
      pageAccess = MarketRoleAccess[CORE_USER]?.pages[currentPath];
    }
  }

  //  Regional
  if (currentVotingTeam === 'Regional Decisions') {
    if (userInfo.role[0] == GENERAL_USER) {
      if (userType !== REGIONAL_USER_TYPE && userType !== CHANNEL_USER_TYPE) {
        pageAccess = MarketRoleAccess['Functional']?.pages[currentPath];
      }
    }
    if (userType === CORE_USER) {
      pageAccess = MarketRoleAccess[CORE_USER]?.pages[currentPath];
    }
  }

  if (currentDecisionTeam && currentPath === '/alignment-action/decision-making-central') {
    if (userType === CORE_USER || userInfo.role[0] === GENERAL_USER) {
      pageAccess = MarketRoleAccess[CORE_USER]?.pages[currentPath];
    }
  }

  if (currentCompletionTeam && currentPath === '/alignment-action/decision-making-central') {
    if (userType === CORE_USER || userInfo.role[0] === GENERAL_USER) {
      pageAccess = MarketRoleAccess[CORE_USER]?.pages[currentPath];
    }
  }

  return pageAccess;
};
